module.exports = "/assets/data/694c02173dcd48dcc94a7822a80c346a-BD8.data.json";